import get from 'lodash/fp/get'
import * as Elasticsearch from '../../elasticsearch'

export interface Counter {
  count?: number,
  rate?: number,
}

export interface UniqueCounter {
  total?: Counter,
  unique?: Counter,
}

export const firstEntry = (parentBucket: any, key: string): any => {
  if (parentBucket && parentBucket.buckets) {
    const children = parentBucket.buckets.filter((b: any) => b.key === key)
    return children ? children[0] : null
  }
  return null
}

export const newCounterEntry = (bucket: any): UniqueCounter => {
  const unique = get(Elasticsearch.AggFieldNames.UniqueCount, bucket)
  return {
    total: {
      count: bucket ? bucket[Elasticsearch.AggFieldNames.DocumentCount] : 0,
    },
    unique: {
      count: unique ? unique.value : bucket ? bucket[Elasticsearch.AggFieldNames.DocumentCount] : 0,
    },
  }
}

/*
 * A bit weird - Opens represents a query against Message Runs.
 * so the Total is the total number of message runs that were opened
 * NOT the total number of OPENS of those message runs.  So the Total
 * is actually a UNIQUE measurement.
 * The Unique Opens is the total number of unique people that opened.
 */
export const updateUniqueRateFromOpens = (
  counter: UniqueCounter,
  opens: UniqueCounter,
): UniqueCounter => {
  return {
    total: counter.total,
    unique: {
      ...counter.unique,
      rate: opens.total.count ? counter.unique.count / opens.total.count * 100 : 0,
    },
  }
}
export const difference = (counter1: UniqueCounter, counter2: UniqueCounter): UniqueCounter => {
  return {
    total: {
      count: counter1.total.count - counter2.total.count,
    },
    unique: {
      count: counter1.unique.count - counter2.unique.count,
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/counters.ts